export default {
  categorySelect: {
    type: 'get',
    url: '/ec-pc-api/product/categorySelect'
  },
  categoryAttr: {
    type: 'get',
    url: '/ec-pc-api/product/categoryAttr'
  },
  productAnalyze: {
    type: 'get',
    url: '/ec-pc-api/product/productAnalyze'
  },
  productGroupAnalyze: {
    type: 'post',
    url: '/ec-pc-api/product/productGroupAnalyze'
  },
  productAnalyzeDetail: {
    type: 'post',
    url: '/ec-pc-api/product/productAnalyzeDetail'
  },
  productAnalyzeExcel: {
    type: 'post',
    url: '/ec-pc-api/product/productAnalyzeExcel'
  },
  filePath: {
    type: 'get',
    url: '/ec-pc-api/async/task/filePath'
  },
  newProductsInTheCurrentYear: {
    type: 'post',
    url: '/ec-pc-api/product/preview/newProductsInTheCurrentYear'
  },
  // productPreviewyear: {
  //   type: 'get',
  //   url: '/ec-pc-api/product/preview/productPreviewyear'
  // },
  soldProducts: { //销售产品上新-年度概览列表
    type: 'post',
    url: '/ec-pc-api/product/preview/soldProducts'
  },
  productSaleNum: {
    type: 'get',
    url: '/ec-pc-api/product/preview/productSaleNum'
  },
  thisYearNewProduct: {
    type: 'get',
    url: '/ec-pc-api/product/preview/thisYear/newProduct'
  },
  monthSaleChart: {
    type: 'post',
    url: '/ec-pc-api/product/preview/monthSaleChart'
  },
  productPrice: {
    type: 'post',
    url: '/ec-pc-api/product/preview/hundredSaleNum/productPrice'
  },
  saleProductList:{//销售产品上新/年度概览列表"
    type: 'post',
    url: '/ec-pc-api/product/preview/saleProductList'
  },
  saleProduct:{//销售产品上新-年度概览导出"
    type: 'post',
    url: '/ec-pc-api/product/preview/export/saleProduct'
  },
  saleProduct:{//销售产品上新-年度概览导出"
    type: 'post',
    url: '/ec-pc-api/product/preview/export/saleProduct'
  },
  hundredSaleNumList:{//月均销量过百的产品价格段分布列表"
    type: 'post',
    url: '/ec-pc-api/product/preview/hundredSaleNumList'
  },
  hundredSaleNum:{//月均销量过百的产品价格段分布列表导出"
    type: 'post',
    url: '/ec-pc-api/product/preview/export/hundredSaleNum'
  },
  saleNumList:{//月均销售数量段分布列表"
    type: 'post',
    url: '/ec-pc-api/product/preview/saleNumList'
  },
  newProSaleNumList:{//新品销量表现列表"
    type: 'post',
    url: '/ec-pc-api/product/preview/newProSaleNumList'
  },
  newProSaleNumListExport:{//新品销量表现列表导出"
    type: 'post',
    url: '/ec-pc-api/product/preview/export/newProSaleNumList'
  },
  priceSegmentDistribution:{//产品表现-价格段分布"
    type: 'post',
    url: '/ec-pc-api/product/preview/productPerformance/priceSegmentDistribution'
  },
  priceSegmentDistrExport:{//产品表现-价格段分布-导出"
    type: 'post',
    url: '/ec-pc-api/product/preview/export/productPerformance/priceSegmentDistribution'
  },
  saleNumListExport:{//月均销售数量段分布列表导出"
    type: 'post',
    url: '/ec-pc-api/product/preview/export/saleNumList'
  },
  salesDataOverTheSamePeriod:{//销售数据同期比"
    type: 'post',
    url: '/ec-pc-api/product/preview/salesDataOverTheSamePeriod'
  },
  interface:{//品类下拉"
    type: 'post',
    url: '/ec-pc-api/product/preview/category/interface'
  },
  salesSamePeriodList:{//同期比导出"
    type: 'post',
    url: '/ec-pc-api/product/preview/export/salesSamePeriodList'
  },
}